<template>
    <div>
      <div style="width:100%;text-align:center;padding-top:147px;">
        <img src="@/assets/img/nofound.png" alt="" style="margin-bottom:28px;">
        <p><span>找不到请求的页面啦！</span></p>
        <p style="margin-top:52px;"><button class="btn_class" @click="replacePath">刷新</button></p>
      </div>
        <!-- <p style="margin:100px auto;font-size:80px;font-weight:700;"> NO FOUND</p> -->
    </div>
</template>
<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  mounted(){
  },
  methods:{
    replacePath(){
      this.$router.replace(this.$router.options.routes[1].children[0].path);
    }
  }
}
</script>
